// Must not use a string to index with, as the env variable is replaced by Next.js to an instance of NodeJS.ProcessEnv
export const notUndefined = <T>(optional?: T, varName?: string): T => {
    if(optional === undefined){
        throw new Error(`${varName ?? 'A variable'} has not been defined.`)
    }
    return optional
}